module.exports = __webpack_public_path__ + "img/flex5_5_Extended-back.cf04c8d4.jpg";